(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('upload3DModelUrlStorageService', upload3DModelUrlStorage);

    upload3DModelUrlStorage.$inject = ['urlService'];

    function upload3DModelUrlStorage(urlService) {
        var service = {
            product: getSetProduct
        };

        return service;

        // --------------------------------------------------------------------------------------------------------------------

        function getSetProduct(productInfo) {
            if (angular.isUndefined(productInfo)) {
                return getProductInfoFromUrl();
            }

            if (productInfo === null || angular.equals({}, productInfo)) {
                urlService.removeHashParameters();
            } else {
                setProductInfoToUrl(productInfo);
            }

            return angular.undefined;
        }

        function setProductInfoToUrl(productInfo) {
            var params = {};

            if (productInfo.modelId) {
                params.modelId = productInfo.modelId;
            }

            if (productInfo.materialId) {
                params.materialId = productInfo.materialId;
            }

            if (productInfo.colourId) {
                params.colourId = productInfo.colourId;
            }

            if (productInfo.productTemplateId) {
                params.productTemplateId = productInfo.productTemplateId;
            }

            if (productInfo.scale) {
                params.scale = productInfo.scale;
            }

            if (productInfo.quantity) {
                params.quantity = productInfo.quantity;
            }

            urlService.setHashParameters(params);
        }

        function getProductInfoFromUrl() {
            var params = urlService.getHashParameters();

            var productInfo = {};

            if (angular.isDefined(params.modelId)) {
                productInfo.modelId = params.modelId;
            }

            if (angular.isDefined(params.materialId)) {
                productInfo.materialId = params.materialId;
            }

            if (angular.isDefined(params.colourId)) {
                productInfo.colourId = params.colourId;
            }

            if (angular.isDefined(params.productTemplateId)) {
                productInfo.productTemplateId = params.productTemplateId;
            }

            if (angular.isDefined(params.scale)) {
                productInfo.scale = parseFloat(params.scale) || angular.undefined;
            }

            if (angular.isDefined(params.quantity)) {
                productInfo.quantity = parseInt(params.quantity, 10) || angular.undefined;
            }

            if (angular.equals({}, productInfo)) {
                return null;
            }

            return productInfo;
        }
    }
})();